import API from "../global/api";
import { getClientList } from "./ProjectList";
export const addClientRequest = () => {
  return {
    type: "ADD_CLIENT_REQUEST",
  };
};
export const addClientSuccess = (data) => {
  return {
    type: "ADD_CLIENT_SUCCESS",
    payload: data,
  };
};
export const addClientError = (msg) => {
  return {
    type: "ADD_CLIENT_ERROR",
    payload: msg
  };
};
export const addClient = (data, handleDangerVisible, handleVisible) => {
  return (dispatch) => {
    dispatch(addClientRequest())
    API.post(`/user/add-project`, data).then((res) => {
        let data1 = res.data;
        dispatch(addClientSuccess(data1));
        dispatch(getClientList());
        handleVisible(res.msg);
      }).catch((error) => {
        dispatch(addClientError(error.response.data.message))
        handleDangerVisible(error.response.data.message)
      });
  };
};